import PropTypes from 'prop-types';
import {EntityIllustration} from 'front-onceforall-core';
import ReadOnlyDocumentsList from '../../readOnlyDocumentList';
import {getOrganisationLogoUrl} from '../../../utils/organisation';
import RemindButton from '../../remindButton';

function OrganisationView(props) {
  const {organisation, documents} = props.organisation;
  const {interventionId = null, project = null} = props.intervention;

  return (
    <div className="card">
      <div className="card-header">
        <div className="flex-container">
          <EntityIllustration
            name={organisation.fullName}
            imageUrl={getOrganisationLogoUrl(organisation.organisationId)}
            country={organisation.country}
          />
          <div className="flex-container column ml-3">
            <strong>{organisation.fullName}</strong>
            <span>{organisation.registrationNumber}</span>
          </div>
        </div>
        <RemindButton
          organisation={organisation}
          interventionId={interventionId}
          project={project}
          country={props.country}
        />
      </div>
      <ReadOnlyDocumentsList
        documents={documents}
      />
    </div>
  );
}

OrganisationView.propTypes = {
  organisation: PropTypes.object.isRequired,
  intervention: PropTypes.object,
  country: PropTypes.string
};

OrganisationView.defaultProps = {
  intervention: {}
};

export default OrganisationView;
